import { cn } from "@/modules/lib/utils"
import { useCallback, useEffect, useRef } from "react"

function Textarea({ className, onChange, ref, ...props }: React.ComponentProps<"textarea">) {
  const internalRef = useRef<HTMLTextAreaElement>(null)

  const adjustHeight = useCallback(() => {
    const textarea = internalRef.current
    if (textarea) {
      textarea.style.height = "auto"
      textarea.style.height = `${textarea.scrollHeight.toString()}px`
    }
  }, [])

  useEffect(() => {
    adjustHeight()
  }, [adjustHeight, props.value])

  return (
    <textarea
      ref={(node) => {
        internalRef.current = node
        if (typeof ref === "function") {
          ref(node)
        } else if (ref && "current" in ref) {
          ref.current = node
        }
      }}
      data-slot="textarea"
      className={cn(
        "md:text-md flex min-h-16 w-full rounded-2xl border border-borderDefault bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary-300 selection:text-textDefault-body placeholder:text-textDefault-placeholder focus-visible:border-borderPrimary focus-visible:ring-[1px] focus-visible:ring-primary-500/50 disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-borderError aria-invalid:ring-borderError/20",
        className,
      )}
      onChange={(e) => {
        adjustHeight()
        onChange?.(e)
      }}
      {...props}
    />
  )
}

export { Textarea }
